import { DocumentContentActions } from "../../documents/documentsApi"
import { SubjectType } from "./systemWorkflowApi"

export const SYS_DOCUMENT_CONTENT_ACTION_RULE_SUBJECT_TYPES: SubjectType[] = [
    "AUTHOR",
    "EDITOR",
    "ADMIN",
    "CURRENT_STAGE_MEMBER",
    "COMPANY_USER",
    "TEAM_MEMBER",
]

export const subjectTypeLabel = (subjectType: SubjectType) => {
    return subjectType
        .split("_")
        .join(" ")
}

export const normalizeSubjectType = (value: string): SubjectType | null => {
    const normalized = value.toUpperCase() as SubjectType
    return SYS_DOCUMENT_CONTENT_ACTION_RULE_SUBJECT_TYPES.includes(normalized)
        ? normalized
        : null
}

export const normalizeActionCode = (value: DocumentContentActions) => {
    return String(value)
}
